// components/NotFound.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box textAlign="center" py={10}>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
                404 - Page Not Found
            </Typography>
            <Typography variant="h6" color="text.secondary" gutterBottom>
                Oops! The page you're looking for doesn’t exist.
            </Typography>
            <Button variant="contained" sx={{
                mt: 3, backgroundColor: 'rgb(0 166 244)', 
                "&:hover": {
                    backgroundColor: "rgb(0 166 244)"
                }
            }} onClick={() => navigate('/')}>
                Go Home
            </Button>
        </Box>
    );
};

export default NotFound;
